export default __webpack_public_path__ + "static/media/mallorca.b1581e7e.jpg";